export default __webpack_public_path__ + "b72e7b7e6085e2d31e249ea2c0999ed1.svg";